import { z } from 'zod'

/** Managerium's dev edge and its dashboard (live is 593), the defaults of a dev build. */
const DEV_DEFAULTS = {
  VITE_MANAGERIUM_BASE_URL: 'https://manageriumedge.dev-tech26.de',
  VITE_MANAGERIUM_DASHBOARD_ID: '38',
}

const envSchema = z.object({
  VITE_MANAGERIUM_BASE_URL: z.string().url(),
  /** Differs per Managerium environment, so it is set at build time. */
  VITE_MANAGERIUM_DASHBOARD_ID: z.coerce.number().int().positive(),
  // Read when Okta starts, so a build running on mocks needs neither.
  VITE_OKTA_ISSUER: z.string().min(1).optional(),
  VITE_OKTA_CLIENT_ID: z.string().min(1).optional(),
  VITE_USE_MOCKS: z.enum(['true', 'false']).optional(),
})

/**
 * The build-time settings, checked: a bad value fails here, not as a request
 * to `/dashboards/NaN`. A production build gets no defaults, so a forgotten
 * setting fails instead of quietly talking to dev.
 */
export const parseEnv = (raw: Record<string, unknown>) => {
  const result = envSchema.safeParse(
    raw['PROD'] === true ? raw : { ...DEV_DEFAULTS, ...raw }
  )
  if (!result.success) {
    const problems = result.error.issues
      .map(issue => `${issue.path.join('.')}: ${issue.message}`)
      .join('; ')
    throw new Error(`Invalid environment, see .env.example (${problems})`)
  }
  const data = result.data
  return {
    manageriumBaseUrl: data.VITE_MANAGERIUM_BASE_URL,
    dashboardId: data.VITE_MANAGERIUM_DASHBOARD_ID,
    oktaIssuer: data.VITE_OKTA_ISSUER,
    oktaClientId: data.VITE_OKTA_CLIENT_ID,
    useMocks: data.VITE_USE_MOCKS === 'true',
  }
}

export const env = parseEnv(import.meta.env)
